var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-dialog',{attrs:{"title":"编辑分组","append-to-body":true,"visible":_vm.dialogFormVisible},on:{"update:visible":function($event){_vm.dialogFormVisible=$event}}},[_vm._t("content"),_vm._t("footer")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }